import React, { useEffect, useState } from 'react';

const CONSENT_KEY = 'cookie_consent_accepted';

const CookieConsentBar = () => {
  const [visible, setVisible] = useState(false);
  const [text, setText] = useState('');

  useEffect(() => {
    // Show only if not accepted (localStorage - kalıcı)
    const accepted = localStorage.getItem(CONSENT_KEY);
    setVisible(!accepted);
  }, []);

  useEffect(() => {
    // Load purpose text from cookies config if available
    const apiBase = process.env.NODE_ENV === 'development' ? 'http://localhost:8000' : '';
    (async () => {
      try {
        const res = await fetch(`${apiBase}/backend/api.php?action=getCookies`);
        const data = await res.json();
        if (Array.isArray(data)) {
          // Prefer necessary active cookie with purpose; else first with purpose
          const preferred = data.find(c => (c.is_active ? 1 : 0) && (c.category === 'necessary') && c.purpose) || data.find(c => (c.is_active ? 1 : 0) && c.purpose);
          if (preferred && preferred.purpose) {
            setText(preferred.purpose);
            return;
          }
        }
      } catch (e) {
        // ignore
      }
      setText('Bu web sitesi deneyiminizi iyileştirmek için çerezleri kullanır. Devam ederek çerez kullanımını kabul etmiş olursunuz.');
    })();
  }, []);

  const accept = () => {
    localStorage.setItem(CONSENT_KEY, '1');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-50">
      <div className="mx-auto max-w-7xl px-4 pb-4">
        <div className="bg-gray-900 text-white rounded-lg shadow-lg p-4 md:p-5 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
          <div className="text-sm md:text-[15px] leading-6">{text}</div>
          <div className="flex items-center gap-2">
            <button onClick={accept} className="inline-flex items-center justify-center rounded-md bg-emerald-500 hover:bg-emerald-600 text-white text-sm font-medium h-9 px-4">
              Kabul Et
            </button>
            <a href="/cerez-politikasi" className="text-sm underline decoration-white/50 hover:decoration-white">Detaylar</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBar;


